export const REASSIGN = 'REASSIGN';
export const CLOSE = 'CLOSE';